import OnRentListElement from './OnRentListElement.container'

export default OnRentListElement
